import { Tooltip } from 'antd';
import React from 'react';
import './style.css';

const CreatedInfo = ({ user, limit = 40 }) => {
  const label = typeof user === 'string' ? user : user?.email || '';
  return (
    <div className="created-by">
      <p>Last modified by:</p>
      {label && label.length > 40 ? (
        <Tooltip title={label}>
          <p>{`${label.substr(0, limit)}...`}</p>
        </Tooltip>
      ) : (
        <p>{label}</p>
      )}
    </div>
  );
};

export default CreatedInfo;
